module.exports = __webpack_public_path__ + "img/Private-Public-Institutes.a40f1588.jpg";